import { Tooltip, Text, Stack, breakpoints, Inline, InfoButton } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const infoIconButtonStyles = css`
  margin-inline-start: 8px;
  margin-top: -3px;

  @media (min-width: ${breakpoints._768}) {
    margin-top: 0;
  }
`;
const priceInfoRowStyles = css`
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
`;
const priceStyles = css`
  align-items: flex-end;
  display: flex;
`;
const SummaryPriceInformationPerCarrier = _ref => {
  let {
    id,
    markup,
    price,
    segmentCarrierName
  } = _ref;
  const {
    t
  } = useTranslation();
  const priceLabel = t('SeatMap.PriceInformation.Price');
  const ariaLabel = t('ScreenReader.PriceSpecification.InfoButton');
  const serviceFeeLabel = t('Product.Markup.Label');
  const productName = t('seatMapTitle');
  const providerCost = price - markup;
  return /*#__PURE__*/_jsx(Tooltip, {
    content: /*#__PURE__*/_jsxs(Stack, {
      spacing: 8,
      children: [/*#__PURE__*/_jsxs(Inline, {
        className: priceInfoRowStyles,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Text, {
          "data-testid": "seatMap-summary-page-tooltip-provider-cost-label",
          children: `${productName} ${segmentCarrierName !== null && segmentCarrierName !== void 0 ? segmentCarrierName : ''}`
        }), /*#__PURE__*/_jsx(Text, {
          className: priceStyles,
          "data-testid": "seatMap-summary-page-tooltip-provider-cost",
          children: priceUtils.formatPrice(providerCost)
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        className: priceInfoRowStyles,
        spacing: 8,
        children: [/*#__PURE__*/_jsx(Text, {
          "data-testid": "seatMap-summary-page-tooltip-markup-label",
          children: serviceFeeLabel
        }), /*#__PURE__*/_jsx(Text, {
          className: priceStyles,
          "data-testid": "seatMap-summary-page-tooltip-markup-fee",
          children: priceUtils.formatPrice(markup)
        })]
      })]
    }),
    "data-testid": `priceInfoTooltipSeatMapPerCarrier-${id}`,
    title: priceLabel,
    children: /*#__PURE__*/_jsx(InfoButton, {
      className: infoIconButtonStyles,
      label: ariaLabel
    })
  });
};
export default SummaryPriceInformationPerCarrier;
//# sourceMappingURL=SummaryPriceInformationPerCarrier.js.map